import { Component, inject, input } from '@angular/core';
import { HostnameService } from '../../../services/hostname.service';

@Component({
    selector: 'sfc-btn-retour',
    templateUrl: './btn-retour.component.html',
    standalone: true,
})
export class BtnRetourComponent{

    class = input<string>();
    text = input<string>();
    hostnameService = inject(HostnameService);
    espaceClientUrl = this.hostnameService.monEspaceClientUrl();
}

